import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow, Grid, Tooltip, IconButton } from '@mui/material';
import EngineScoringClassificationFinancialIndicatorListItemComponent from './EngineScoringClassificationFinancialIndicatorListItemComponent';
import { Add } from '@mui/icons-material';
import { getErrors } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';

const EngineScoringClassificationFinancialIndicatorListComponent = ({
  financialIndicators,
  engineClassificationIndex,
  isReadOnly,
  validation,
  dispatch,
  scoringFinancialIndicatorOptions
}) => {
  const { t } = useTranslation();
  const onAddNewFinancialIndicator = () => {
    dispatch({
      type: 'OnAddNewClassificationFinancialIndicator',
      classificationIndex: engineClassificationIndex
    });
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('EngineScoring.EngineClassifications.FinancialIndicator.OrderNo')}</TableCell>
              <TableCell>{t('EngineScoring.EngineClassifications.FinancialIndicator.FinancialIndicatorName')}</TableCell>
              <TableCell>{t('EngineScoring.EngineClassifications.FinancialIndicator.Mandatory')}</TableCell>
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {financialIndicators.map((item, idx) => {
              return (
                <EngineScoringClassificationFinancialIndicatorListItemComponent
                  key={idx}
                  financialIndicator={item}
                  dispatch={dispatch}
                  financialIndicatorIndex={idx}
                  classificationIndex={engineClassificationIndex}
                  scoringFinancialIndicatorOptions={scoringFinancialIndicatorOptions}
                  validation={validation[idx]}
                  isReadOnly={isReadOnly}
                />
              );
            })}
          </TableBody>
        </Table>
      </Grid>
      <Grid item xs={11}>
        <Typography color='error'>{validation |> getErrors}</Typography>
      </Grid>
      <Grid item xs={1} sx={{ textAlign: 'right' }}>
        <Tooltip title={t('Tooltips.EngineScoringGrid.AddFinancialIndicator')}>
          <IconButton onClick={onAddNewFinancialIndicator} color='primary' disabled={isReadOnly}>
            <Add />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

EngineScoringClassificationFinancialIndicatorListComponent.propTypes = {
  financialIndicators: PropTypes.array.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  scoringFinancialIndicatorOptions: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  engineClassificationIndex: PropTypes.number.isRequired,
  validation: PropTypes.object.isRequired
};

export default EngineScoringClassificationFinancialIndicatorListComponent;
